import type { Locale, TranslationKeys } from "../types.js";
import { es } from "./es.js";
import { en } from "./en.js";
import { fr } from "./fr.js";
import { pt } from "./pt.js";

export const translations: Record<Locale, TranslationKeys> = {
  es,
  en,
  fr,
  pt,
};

export function getTranslation(locale: Locale = "es"): TranslationKeys {
  return translations[locale] ?? translations.es;
}

/**
 * Traduce una clave usando el locale especificado
 * Soporta parámetros dinámicos con {{param}}
 */
export function t(
  locale: Locale,
  key: string,
  params?: Record<string, string | number>
): string {
  const translation = getTranslation(locale);
  const keys = key.split(".");
  
  // Navegar por el objeto de traducción
  let value: unknown = translation;
  for (const k of keys) {
    if (typeof value === "object" && value !== null && k in value) {
      value = (value as Record<string, unknown>)[k];
    } else {
      console.warn(`Translation key not found: ${key} for locale: ${locale}`);
      return key; // Retornar la clave si no se encuentra
    }
  }
  
  if (typeof value !== "string") {
    console.warn(`Translation value is not a string: ${key} for locale: ${locale}`);
    return key;
  }
  
  // Reemplazar parámetros {{param}}
  if (params) {
    return value.replace(/\{\{(\w+)\}\}/g, (match, param) => {
      return params[param]?.toString() ?? match;
    });
  }
  
  return value;
}

// Re-exportar traducciones individuales para next-intl
export { es, en, fr, pt };
